export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_TOTAL_RECORDS = 'SET_TOTAL_RECORDS';
export const SET_PAGE = 'SET_PAGE';
export const EDIT_PARTNER_STAFF = 'EDIT_PARTNER_STAFF';
export const ADD_PARTNER_STAFF = 'ADD_PARTNER_STAFF';
export const DELETE_PARTNER_STAFFS = 'DELETE_PARTNER_STAFFS';
export const PARTNER_STAFFS_LOADING = 'PARTNER_STAFFS_LOADING';
export const PARTNER_STAFFS_FAILURE = 'PARTNER_STAFFS_FAILURE';
export const GET_PARTNER_STAFFS = 'GET_PARTNER_STAFFS';
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL';
export const GET_ALL_STAFF_BRANCH = 'GET_ALL_STAFF_BRANCH';


export const PARTNER_STAFF_PROGRESS_TYPE={
    GET_PARTNER_STAFF_LIST:"GET_PARTNER_STAFF_LIST",
    ADD_PARTNER_STAFF_PROGRESS:"ADD_PARTNER_STAFF_PROGRESS",
    EDIT_PARTNER_STAFF_PROGRESS:"EDIT_PARTNER_STAFF_PROGRESS",
    DELETE_PARTNER_STAFF_PROGRESS:"DELETE_PARTNER_STAFF_PROGRESS"
}

